import React from "react";
import imageCompression from "browser-image-compression";

export default function CompressedFileInput({ onChange, maxTotalSizeMB = 4, ...props }) {
  const handleChange = async (e) => {
    const { name, files } = e.target;

    if (!files) return;

    const originalFiles = Array.from(files);
    const maxTotalSizeBytes = maxTotalSizeMB * 1024 * 1024;
    
    let remainingSize = maxTotalSizeBytes;
    const compressedFiles = [];

    // Process files sequentially to better control total size
    for (const file of originalFiles) {
      if (!file.type.startsWith("image/")) {
        // For non-image files, check if we have space
        if (file.size <= remainingSize) {
          compressedFiles.push(file);
          remainingSize -= file.size;
        } else {
          alert(`Le fichier ${file.name} est trop volumineux pour être ajouté.`);
          continue;
        }
        continue;
      }

      try {
        // Calculate target size for this file based on remaining budget
        const estimatedFileSize = Math.min(
          file.size, 
          remainingSize * 0.8 // Use 80% of remaining space for this file
        );
        
        const targetSizeMB = estimatedFileSize / (1024 * 1024);
        

        const compressedFile = await imageCompression(file, {
          maxSizeMB: targetSizeMB,
          maxWidthOrHeight: 1600,
          useWebWorker: true,
          initialQuality: 0.7,
        });

        if (compressedFile.size <= remainingSize) {
          compressedFiles.push(compressedFile);
          remainingSize -= compressedFile.size;
        } else {
          // Try one more time with more aggressive compression
          const finalCompressedFile = await imageCompression(file, {
            maxSizeMB: remainingSize / (1024 * 1024),
            maxWidthOrHeight: 1200,
            useWebWorker: true,
            initialQuality: 0.5,
          });
          
          if (finalCompressedFile.size <= remainingSize) {
            compressedFiles.push(finalCompressedFile);
            remainingSize -= finalCompressedFile.size;
          } else {
            alert(`Impossible d'ajouter ${file.name} - taille maximale totale atteinte.`);
          }
        }
      } catch (err) {
        console.error("Compression failed for file:", file.name, err);
        // Try to add original if it fits
        if (file.size <= remainingSize) {
          compressedFiles.push(file);
          remainingSize -= file.size;
        } else {
          alert(`Le fichier ${file.name} est trop volumineux.`);
        }
      }
    }

    // Calculate final total size
    const totalSize = compressedFiles.reduce((total, file) => total + file.size, 0);
    const totalSizeMB = (totalSize / (1024 * 1024)).toFixed(2);
    
    console.log(`📊 Taille totale après compression: ${totalSizeMB}MB / ${maxTotalSizeMB}MB`);
    
    if (compressedFiles.length > 0) {
      onChange && onChange({ target: { name, files: compressedFiles } });
    } else {
      alert("Aucun fichier n'a pu être ajouté dans la limite de taille.");
    }
  };

  return <input {...props} onChange={handleChange} />;
}